import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-54d7035a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "view-mode-button-container" };
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_FriedIconButton = _resolveComponent("FriedIconButton");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['slider-top-bar-container', { 'lightbox-top-bar': _ctx.isLightboxView }])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_FriedIconButton, {
                class: _normalizeClass(['grid-view-button icon-button-dark', { active: _ctx.isGridView }]),
                "data-external": "editor-button-slideshow-card-view",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('toggle-grid-view', !_ctx.isGridView)))
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_FriedIcon, { icon: "card" })
                ]),
                _: 1
            }, 8, ["class"]),
            (_ctx.isLightboxView)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: _ctx.route,
                    custom: ""
                }, {
                    default: _withCtx(({ navigate }) => [
                        _createElementVNode("div", {
                            role: "link",
                            onClick: navigate
                        }, [
                            _createVNode(_component_FriedIconButton, {
                                "data-external": "editor-button-slideshow-lightbox-view",
                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('toggle-lightbox')))
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_FriedIcon, { icon: "arrow-collapse" })
                                ]),
                                _: 1
                            })
                        ], 8, _hoisted_2)
                    ]),
                    _: 1
                }, 8, ["to"]))
                : _createCommentVNode("", true)
        ])
    ], 2));
}
